/**
 * ¿De qué socio es el `?ref=` que trajo a esta persona?
 * `GET /job-apply/api/referral/partner?code=CODIGO`.
 *
 * Existe para el aviso de consentimiento (Ley 1581): el socio ve en su panel el
 * correo y el estado del plan de cada persona que se registra con su código, y
 * esa persona tiene que saberlo ANTES de que sus datos le lleguen. El `?ref=` se
 * estampa en silencio al terminar el alta (`syncPendingReferral`), así que el
 * aviso sale durante el alta, con el nombre del socio que contesta acá.
 *
 * Estados y no `throw`, como `couponClient`:
 *
 *  - `partner` → el código es de un socio; `name` puede venir null.
 *  - `none`    → no es de ningún socio: nadie va a ver sus datos, no hay aviso.
 *  - `unknown` → no se pudo preguntar. El aviso sale IGUAL, con el código en
 *                vez del nombre: avisar de más es barato, callar no.
 */
import { apiFetch } from '~/lib/api';

export type ReferralPartnerResult =
  | { status: 'partner'; name: string | null }
  | { status: 'none' }
  | { status: 'unknown' };

export async function fetchReferralPartner(code: string): Promise<ReferralPartnerResult> {
  try {
    const res = await apiFetch(`/job-apply/api/referral/partner?code=${encodeURIComponent(code)}`);
    if (!res.ok) return { status: 'unknown' };
    const body = (await res.json().catch(() => null)) as {
      partner?: { code?: string; partner_name?: string | null } | null;
    } | null;
    if (!body || !('partner' in body)) return { status: 'unknown' };
    if (!body.partner) return { status: 'none' };
    const name = typeof body.partner.partner_name === 'string' ? body.partner.partner_name.trim() : '';
    return { status: 'partner', name: name || null };
  } catch {
    return { status: 'unknown' };
  }
}
